<template>
  <div>
    <div class="filters-btn" v-show="!filtersVisible" @click="toggleFilters"> {{ filters }} </div>
    <div class="filters-title" v-show="filtersVisible">
      {{ resourcesFilters }}
    </div>
    <div class="switchers" :class="{ 'visible': filtersVisible }">
      <div v-if="topics.length > 0" class="switcher">
        <div class="styled-select-list">
          <div class="select-list">
            <div class="current-selected">
              <button> 
                <template> {{ selectedTopic.name }} </template>
              </button> 
              <div class="caret"></div>
            </div>
            <div class="select-options">
              <ul>
                <button v-show="topicTid != 0 && topicTid != null" class="select-option" key="all" v-on:keyup.enter="onEnter('topic', null)">
                  <input type="radio" key="all" class="select-option" id="all-topics" v-model="topicTid" :value="null" /> 
                  <label for="all-topics"> {{ anyTopic }} </label>
                </button>
                <template v-for="(topic, id, index) in topics">
                  <button v-show="selectedTopic && topic.tid != selectedTopic.tid" class="select-option" :key="index" v-on:keyup.enter="onEnter('topic', topic.tid)">
                    <input type="radio" :key="index" class="select-option" :id="topic.tid" v-model="topicTid" :value="topic.tid" /> 
                    <label :for="topic.tid"> {{ topic.name }} </label>
                  </button>
                </template>
              </ul>
            </div>
          </div>
        </div>	
      </div>
      <div v-if="resourceTypes.length > 0" class="switcher">
        <div class="styled-select-list">
          <div class="select-list">
            <div class="current-selected">
              <button> 
                <template> {{ selectedResourceType.name }} </template>
              </button> 
              <div class="caret"></div>
            </div>
            <div class="select-options">
              <ul>
                <button v-show="resourceTypeTid != 0 && resourceTypeTid != null" class="select-option" key="all" v-on:keyup.enter="onEnter('type', null)">
                  <input type="radio" key="all" class="select-option" id="all-resourcetypes" v-model="resourceTypeTid" :value="null" /> 
                  <label for="all-resourcetypes"> {{ anyResourceType }} </label>
                </button>
                <template v-for="(resourceType, id, index) in resourceTypes">
                  <button v-show="selectedResourceType && resourceType.tid != selectedResourceType.tid" class="select-option" :key="index" v-on:keyup.enter="onEnter('type', resourceType.tid)">
                    <input type="radio" :key="index" class="select-option" :id="resourceType.tid" v-model="resourceTypeTid" :value="resourceType.tid" /> 
                    <label :for="resourceType.tid"> {{ resourceType.name }} </label>
                  </button>
                </template>
              </ul>
            </div>
          </div>
        </div>	
      </div>
      <div v-if="languages.length > 0" class="switcher">
        <div class="styled-select-list">
          <div class="select-list">
            <div class="current-selected">
              <button> 
                <template> {{ selectedLanguage.name }} </template>
              </button> 
              <div class="caret"></div>
            </div>
            <div class="select-options">
              <ul>
                <template v-for="(languageItem, id, index) in languages">
                  <button v-show="selectedLanguage && languageItem.id != selectedLanguage.id" class="select-option" :key="index" v-on:keyup.enter="onEnter('language', languageItem.id)">
                    <input type="radio" :key="index" class="select-option" :id="languageItem.id" v-model="languageId" :value="languageItem.id" /> 
                    <label :for="languageItem.id"> {{ languageItem.name }} </label>
                  </button>
                </template>
              </ul>
            </div>
          </div>
        </div>	
      </div>
    </div>
    <div class="apply-filters" v-show="filtersVisible" @click="toggleFilters"> {{ useFilters }} </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import content from '@/translations/content'

export default {
  name: 'Switchers',
  mixins: [ content ],
  data() {
    return {
      filtersVisible: false,
      topicTid: 0,
      resourceTypeTid: 0,
      languageId: '',
    }
  },
  methods: {
    toggleFilters() {
      this.filtersVisible = !this.filtersVisible
      this.$emit('input', { 
        filtersVisible: this.filtersVisible,
        topicTid: this.topicTid,
        resourceTypeTid: this.resourceTypeTid,
        languageId: this.languageId
      })
    },
    onEnter: function(type, id) {
      if (type == "topic")
        this.topicTid = id
      else if (type == "type")
        this.resourceTypeTid = id 
      else if (type == "language")
        this.languageId = id
    }
  },
  computed: {
    selectedTopic() { 
      if ((this.topicTid != 0) && (this.topicTid != null))
        return this.topics.find(topic => topic.tid == this.topicTid) 
      else if (this.resourceTypeTid == null) 
        return { tid: 0, name: this.anyTopic }
      else
        return { tid: 0, name: this.topicLabel }
    },
    selectedResourceType() { 
      if ((this.resourceTypeTid != 0) && (this.resourceTypeTid != null))
        return this.resourceTypes.find(resourceType => resourceType.tid == this.resourceTypeTid) 
      else if (this.resourceTypeTid == null) 
        return { tid: 0, name: this.anyResourceType }
      else
        return { tid: 0, name: this.resourceTypeLabel }
    },
    selectedLanguage() {
      if (this.languageId != 0)
        return this.languages.find(language => language.id == this.languageId) 
      else
        return { id: this.language, name: this.languageLabel }
    },
    properties() {
      return {
        filtersVisible: this.filtersVisible,
        topicTid: this.topicTid,
        resourceTypeTid: this.resourceTypeTid,
        languageId: this.languageId
      }
    },
    ...mapState(['topics', 'resourceTypes', 'languages', 'language'])
  },
  watch: {
    selectedTopic: function() {
      this.$emit('input', this.properties)
      this.$emit('updateFilters')
    },
    selectedResourceType: function() {
      this.$emit('input', this.properties)
      this.$emit('updateFilters')
    },
    selectedLanguage: function() {
      this.topicTid = 0
      this.resourceTypeTid = 0
      this.$emit('input', this.properties)
      this.$emit('updateResources')
    }
  }
}
</script>